import { buttonBaseStyles } from "@store/theme/common/mixins";
import { TYPOGRAPHY } from "@store/theme/design";
import { css } from "styled-components";

const buttonType = {
    solid: "solid",
    outline: "outline",
};

const baseProps = {
    hoverMode: "lighten",
    activeMode: "darken",
    sizeVariant: "medium",
    typographyProps: {
        weight: TYPOGRAPHY.weight.black,
        size: TYPOGRAPHY.size.smaller,
    },
    shape: "rounded",
};

export default {
    primary: {
        ...baseProps,
        color: "primary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
    secondary: {
        ...baseProps,
        color: "secondary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
    tertiary: {
        ...baseProps,
        color: "secondary",
        buttonType: buttonType.outline,
        css: css`
            ${buttonBaseStyles(buttonType.outline)}
        `,
    },
    quarternary: {
        ...baseProps,
        color: "quarternary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
    quinary: {
        ...baseProps,
        color: "quinary",
        buttonType: buttonType.solid,
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
    defaultProps: {
        css: css`
            ${buttonBaseStyles(buttonType.solid)}
        `,
    },
};
